import IAction from "../store/IAction"
import ICitizenVm from "../models/shared/ICitizenVm"
import InitState from "../store/initState"
import addressReducer from "./addressReducer"
import ICountryVm from "../models/shared/ICountryVm"

const UPDATE_CIVIL_REGISTRATION_IDENTIFIER = "BAT2/citizen/UPDATE_CIVIL_REGISTRATION_IDENTIFIER"
const UPDATE_LAST_NAME = "BAT2/citizen/UPDATE_LAST_NAME"
const UPDATE_FIRST_NAME = "BAT2/citizen/UPDATE_FIRST_NAME"
const UPDATE_PHONE = "BAT2/citizen/UPDATE_PHONE"
const UPDATE_USE_SECONDARY_ADDRESS = "BAT2/application/UPDATE_USE_SECONDARY_ADDRESS"
const UPDATE_BIRTH_PLACE_COUNTRY = "BAT2/application/UPDATE_BIRTH_PLACE_COUNTRY"
const UPDATE_NATIONALITY = "BAT2/application/UPDATE_NATIONALITY"
const UPDATE_USE_CUSTOM_NAME_ON_CERTIFICATE = "BAT2/application/UPDATE_USE_CUSTOM_NAME_ON_CERTIFICATE"
const UPDATE_CUSTOM_FIRST_NAME = "BAT2/application/UPDATE_CUSTOM_FIRST_NAME"
const UPDATE_CUSTOM_LAST_NAME = "BAT2/application/UPDATE_CUSTOM_LAST_NAME"

export default function citizenReducer(state: ICitizenVm = new InitState().citizen, action: IAction): ICitizenVm {
    if (state.id === action.id) {
        switch (action.type) {
            case UPDATE_CIVIL_REGISTRATION_IDENTIFIER:
                return { ...state, civilRegistrationIdentifier: action.payload }
            case UPDATE_FIRST_NAME:
                return { ...state, firstName: action.payload }
            case UPDATE_LAST_NAME:
                return { ...state, lastName: action.payload }
            case UPDATE_PHONE:
                return { ...state, phone: action.payload }
            case UPDATE_BIRTH_PLACE_COUNTRY:
                return { ...state, birthPlaceCountry: action.payload }
            case UPDATE_NATIONALITY:
                return { ...state, nationality: action.payload }
            case UPDATE_USE_CUSTOM_NAME_ON_CERTIFICATE:
                return { ...state, useCustomNameOnCertificate: action.payload }
            case UPDATE_CUSTOM_FIRST_NAME:
                return { ...state, customFirstName: action.payload }
            case UPDATE_CUSTOM_LAST_NAME:
                return { ...state, customLastName: action.payload }
            case UPDATE_USE_SECONDARY_ADDRESS:
                if (!state.secondDeliveryAddress.countryName) {
                    return {
                        ...state,
                        useSecondDeliveryAddress: action.payload,
                        secondDeliveryAddress: {
                            ...state.secondDeliveryAddress,
                            countryName: "Danmark",
                            countryCode: "DK"
                        }
                    }
                } else {
                    return { ...state, useSecondDeliveryAddress: action.payload }
                }
            default:
                {
                    return state
                }
        }
    } else {
        return {
            ...state,
            address: addressReducer(state.address, action),
            secondDeliveryAddress: addressReducer(state.secondDeliveryAddress, action)
        }
    }

}
export function updateUseSecondaryAddress(citizenId: string, isChecked: boolean) {
    return { type: UPDATE_USE_SECONDARY_ADDRESS, payload: isChecked, id: citizenId }
}
export function updateCivilRegistrationIdentifier(civilRegistrationIdentifier: string, id: string) {
    return { type: UPDATE_CIVIL_REGISTRATION_IDENTIFIER, payload: civilRegistrationIdentifier.replace("-", ""), id }
}
export function updateFirstName(name: string, id: string) {
    return { type: UPDATE_FIRST_NAME, payload: name, id }
}
export function updateLastName(lastName: string, id: string) {
    return { type: UPDATE_LAST_NAME, payload: lastName, id }
}
export function updatePhone(phone: string, id: string) {
    return { type: UPDATE_PHONE, payload: phone, id }
}
export function updateBirthPlaceCountry(value: ICountryVm, id: string) {
    return { type: UPDATE_BIRTH_PLACE_COUNTRY, payload: value, id }
}
export function updateNationality(value: ICountryVm, id: string) {
    return { type: UPDATE_NATIONALITY, payload: value, id }
}
export function updateUseCustomNameOnCertificate(value: boolean, id: string) {
    return { type: UPDATE_USE_CUSTOM_NAME_ON_CERTIFICATE, payload: value, id }
}
export function updateCustomFirstName(value: string, id: string) {
    return { type: UPDATE_CUSTOM_FIRST_NAME, payload: value, id }
}
export function updateCustomLastName(value: string, id: string) {
    return { type: UPDATE_CUSTOM_LAST_NAME, payload: value, id }
}